import { z } from 'zod';
import { api } from './client';
import {
  cleanParams,
  paginatedSchema,
  roleSchema,
  type ListParams,
  type Paginated,
} from './schemas';

export const activityLogSchema = z.looseObject({
  id: z.number(),
  user_id: z.number().nullish(),
  username: z.string().nullish(),
  display_name: z.string().nullish(),
  role: roleSchema.nullish(),
  action: z.string(),
  entity_type: z.string().nullish(),
  entity_id: z.union([z.string(), z.number()]).nullish(),
  details: z.unknown().nullish(),
  created_at: z.string(),
});
export type ActivityLog = z.infer<typeof activityLogSchema>;

export interface ActivityLogParams extends ListParams {
  user_id?: number | '';
  role?: string;
  action?: string;
  entity_type?: string;
  entity_id?: string;
  /** `YYYY-MM-DD`, Colombo days, inclusive. */
  date_from?: string;
  date_to?: string;
}

export async function listActivityLogs(
  params: ActivityLogParams = {},
): Promise<Paginated<ActivityLog>> {
  const { data } = await api.get('/activity-logs', { params: cleanParams(params) });
  return paginatedSchema(activityLogSchema).parse(data);
}
